import { useEffect, useRef } from 'react';

/**
 * Stable ref that always holds the latest render's value. For handing the
 * newest callback/value to a long-lived consumer (debounce, subscription,
 * timer) without recreating it per render — the consumer stays stable and
 * reads `.current` at fire time.
 */
export const useLatestRef = <T>(value: T) => {
  const ref = useRef(value);
  useEffect(() => {
    ref.current = value;
  });
  return ref;
};
